import React from 'react';
import Dialog from 'components/Dialogs/Dialog';
import { ActionDialogProps } from './ActionDialog.props';

const ActionDialog = ({ open, title, subtitle, children, handleDialogClose }: ActionDialogProps) => (
  <Dialog
    title={title}
    subtitle={subtitle}
    open={open}
    onClose={handleDialogClose}
    PaperProps={{ style: { width: '25vw' } }}>
    {children}
  </Dialog>
);

export default ActionDialog;
